import { Dispatch } from "react";

interface User {
	uid: string;
	firstName: string;
	lastName: string;
	displayName: string;
	mail: string;
	tz?: string;
	prefTz?: string;
	active?: boolean;
	title?: string;
	department?: string;
	company?: string | null;
	authEnabled?: boolean;
	office?: string;
	address?: string;
	city?: string;
	state?: string;
	country?: string;
}

export interface FinOpsSector {
	id: string;
	name: string;
}

export interface StateTypes {
	authType: string | null;
	user: string | null;
	profile: string | null | User;
	accessToken: any | null;
	role: any | null;
	capabilities: any | null;
	isAuthenticated: boolean;
	privilege?: 'Admin' | 'Approver' | 'Viewer';
	sector?: FinOpsSector | null;
	sectorViewer?: FinOpsSector[];
}

export type ActionTypes =
	| { type: 'CLEAR_AUTH_CACHE' }
	| { type: 'SET_AUTH_TYPE'; value: StateTypes['authType'] }
	| { type: 'SET_USER'; value: StateTypes['user'] }
	| { type: 'SET_PROFILE'; value: StateTypes['profile'] }
	| { type: 'SET_TOKEN'; value: StateTypes['accessToken'] }
	| { type: 'SET_AUTHENTICATED'; value: StateTypes['isAuthenticated'] }
	| { type: 'SET_ROLE'; value: StateTypes['role'] }
	| { type: 'SET_CAPABILITIES'; value: StateTypes['capabilities'] }
	| { type: 'SET_PRIVILEGE'; value: StateTypes['privilege'] }
	| { type: 'SET_SECTOR'; value: StateTypes['sector'] }
	| { type: 'SET_SECTOR_VIEWER'; value: StateTypes['sectorViewer'] };

// Add ActionTypes type to AUTH_ACTIONS
export const AUTH_ACTIONS = [
	'CLEAR_AUTH_CACHE',
	'SET_USER',
	'SET_PROFILE',
	'SET_AUTH_TYPE',
	'SET_TOKEN',
	'SET_ROLE',
	'SET_CAPABILITIES',
	'SET_AUTHENTICATED',
	'SET_PRIVILEGE',
	'SET_SECTOR',
	'SET_SECTOR_VIEWER'
];

export type PepwiseAuthContextType = [StateTypes, Dispatch<ActionTypes>];
